import {BaseClass} from '../../classes/baseClass';
import Thumbnail from '../../classes/thumbnail';
import {formatUrl} from '../../helpers';

export default class Person extends BaseClass {
  constructor({
    id,
    username,
    email,
    fullName,
    firstName,
    lastName,
    avatar,
    type,
    createdAt,
    karma,
    internal,
  } = {}) {
    super();

    this.id = id;
    this.username = username;
    this.email = email;
    this.fullName = fullName;
    this.firstName = firstName;
    this.lastName = lastName;
    this.avatar = Thumbnail.map(avatar);
    this.type = type;
    this.createdAt = createdAt;
    this.karma = karma;
    this.internal = internal;
  }

  get isUser() {
    return this.type === 'user';
  }

  get isCustomer() {
    return !this.isUser;
  }

  /**
   * @return {String}
   */
  get url() {
    return this.isCustomer ? `/customers/view/${this.id}` : `/user/${this.id}`;
  }

  incrementKarma() {
    return this.updateKarma(this.karma + 1);
  }

  decrementKarma() {
    return this.updateKarma(this.karma - 1);
  }

  updateKarma(karma) {
    if (this.isCustomer) {
      return $axios
        .post(formatUrl(`/omnis/v3/atlas/customer/${this.id}/karma/update/`), {
          karma,
        })
        .handle(403, () => {
          snackbar.error('Permission denied');
        })
        .validation()
        .oops();
    }

    return null;
  }
}
